"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  init: function init() {
    // JavaScript to be fired on all pages
  },
  finalize: function finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js